export function convertFormat(str = "yyyy-MM-dd'T'HH:mm:ssxxx") {
  const map = {
    'YYYY-MM-DD': 'yyyy-MM-dd',
    'ddd, MMM D': 'E, MMM d',
    'MM/DD/YYYY': 'MM/dd/yyyy',
    ddd: 'E',
    'MM/DD': 'MM/dd',
    'ddd M/D': 'E M/d',
    YYYYMMDD: 'yyyyMMdd',
    'YYYY-MM-DDTHH:mm:ss': "yyyy-MM-dd'T'HH:mm:ss",
    'M/D': 'M/d',
    llll: 'E, PP p', // e.g) Wed, Aug 30, 2023, 11:50 AM
    'h:mmA': 'h:mma',
    'h:mm A': 'h:mm a',
    'dddd HH:mm': 'EEEE HH:mm',
    'dddd h:mm a': "EEEE h:mm aaaaa'm'",
    'ddd HH:mm': 'EEE HH:mm',
    'ddd h:mm[a]': "EEE h:mmaaaaa",
    'ddd h:mm[p]': "EEE h:mmaaaaa",
    'h:mm a': "h:mm aaaaa'm'",
  }

  if (map?.[str]) {
    return map[str]
  }

  return str
}
